document.addEventListener('DOMContentLoaded', function() {
  const jSliders = document.querySelectorAll('.j-slider');
  const ACTIVE_ATTR = 'data-active'

  jSliders.forEach((slider) => {
    const jPrev = slider.querySelector('.j-prev');
    const jNext = slider.querySelector('.j-next');
    const jScroll = slider.querySelector('.j-scroll');
    const jIndicates = slider.querySelector('.j-indicates')
    jPrev.style.visibility = 'hidden';
    let index = 0;

    const updateIndicates = () => {
      if (!jIndicates) return
      jIndicates.querySelector(`[${ACTIVE_ATTR}]`)?.removeAttribute(ACTIVE_ATTR)
      jIndicates.children[index]?.setAttribute(ACTIVE_ATTR, true)
    }

    const clientWidth = jScroll.clientWidth;
    const scrollWidth = jScroll.scrollWidth;

    jScroll.scrollTo({ left: 0 })
    updateIndicates()

    if (scrollWidth == clientWidth) {
      jPrev.style.visibility = 'hidden';
      jNext.style.visibility = 'hidden';
    }

    // prev
    jPrev.addEventListener('click', function() {
      const scrollWidth = jScroll.scrollWidth;
      const scrollLeft = jScroll.scrollLeft;
      const clientWidth = jScroll.clientWidth;
      const scrollLeftValue = scrollLeft - clientWidth;
      if (scrollLeftValue / clientWidth <= 0.1) {
        event.target.style.visibility = 'hidden'
      }
      jNext.style.visibility = 'visible'
      index -= 1;
      jScroll.scrollTo({
        left: Math.min(scrollLeftValue, 0),
        behavior: 'smooth'
      });
      updateIndicates();
    });
    // next
    jNext.addEventListener('click', function(event) {
      const scrollWidth = jScroll.scrollWidth;
      const scrollLeft = jScroll.scrollLeft;
      const clientWidth = jScroll.clientWidth;
      const scrollLeftValue = scrollLeft + clientWidth;
      if ((scrollLeftValue + clientWidth) / scrollWidth > 0.9) {
        event.target.style.visibility = 'hidden'
      }
      jPrev.style.visibility = 'visible'
      index += 1;
      jScroll.scrollTo({
        left: Math.min(scrollLeftValue, scrollWidth),
        behavior: 'smooth'
      });
      updateIndicates()
    });
  });
});